import { QueryStatus } from '@adv-frontend/modules-query';
import { useGSCIntegrationHealth } from '#entities/integration';
import { GOOGLE_VERIFICATION_SETTING_PATH, SITE_NOT_PUBLISHED_GSC_GUARD } from './constants';
import { getSiteVerificationConnectionStatus } from './getSiteVerificationConnectionStatus';
import { isQueryStatusResolved } from './status';
import { useIsSitePublished } from './useIsSitePublished';
import { useVerificationCodeSetting } from './useVerificationCodeSetting';

interface UseGscSiteVerificationStatusParams {
    skip?: boolean;
    skipSitePublishedStatus?: boolean;
}

export const useGscSiteVerificationStatus = ({
    skip = false,
    skipSitePublishedStatus = false,
}: UseGscSiteVerificationStatusParams = {}) => {
    const { status: automaticStatus, refetch: refetchAutomaticStatus } = useGSCIntegrationHealth(undefined, {
        skip,
    });
    const {
        queryStatus: verificationCodeStatus,
        setting,
        verificationCode,
    } = useVerificationCodeSetting(GOOGLE_VERIFICATION_SETTING_PATH, {
        skip,
    });
    const isSitePublished = useIsSitePublished({ skip: skip || skipSitePublishedStatus });
    const isAutomaticallyConnected = automaticStatus === QueryStatus.fulfilled;
    const { hasVerificationCode, isConnected } = getSiteVerificationConnectionStatus({
        isAutomaticallyConnected,
        verificationCode,
    });

    return {
        automaticStatus,
        guardReason:
            skipSitePublishedStatus || isConnected || isSitePublished ? undefined : SITE_NOT_PUBLISHED_GSC_GUARD,
        hasVerificationCode,
        isAutomaticallyConnected,
        isConnected,
        isConnectionStatusResolved:
            skip ||
            isConnected ||
            (isQueryStatusResolved(automaticStatus) && isQueryStatusResolved(verificationCodeStatus)),
        isSitePublished,
        refetchAutomaticStatus,
        setting,
        verificationCode,
        verificationCodeStatus,
    };
};
